module.exports = __webpack_public_path__ + "static/media/networks-black.f07b19f2.svg";